// Chave (parametros_sistema) com as janelas de acesso por perfil e dia da semana.
export const CHAVE_HORARIOS_ACESSO = 'acesso.horarios_por_perfil'
